// React
import { useState } from 'react'

// Interfaces
import { IBaseForm } from 'interfaces/form'

// Constant
import { FORM_INPUT } from 'constant/form.constant'

const useContactUsForm = () => {
  const [fields] = useState<IBaseForm[]>([
    {
      label: { label: 'contactUs.form.email', layout: 'vertical' },
      input: {
        inputName: FORM_INPUT.TEXT_FIELD,
        formName: 'email',
        breakpoint: 24,
        rules: ['required', 'email'],
        inputAttrs: {
          placeholder: 'contactUs.formPlaceholder.email',
        },
      },
    },
    {
      label: { label: 'contactUs.form.name', layout: 'vertical' },
      input: {
        inputName: FORM_INPUT.TEXT_FIELD,
        formName: 'name',
        breakpoint: 24,
        rules: ['required'],
        inputAttrs: {
          placeholder: 'contactUs.formPlaceholder.name',
        },
      },
    },
    {
      label: { label: 'contactUs.form.questionTitle', layout: 'vertical' },
      input: {
        inputName: FORM_INPUT.TEXT_FIELD,
        formName: 'title',
        breakpoint: 24,
        rules: ['required'],
        inputAttrs: {
          placeholder: 'contactUs.formPlaceholder.questionTitle',
        },
      },
    },
    {
      label: { label: 'contactUs.form.message', layout: 'vertical' },
      input: {
        inputName: FORM_INPUT.TEXT_AREA,
        formName: 'message',
        breakpoint: 24,
        rules: ['required'],
        inputAttrs: {
          placeholder: 'contactUs.formPlaceholder.message',
        },
      },
    },
  ])

  return { fields }
}

export { useContactUsForm }
